export interface MenuItem {
  label: string;
  icon: string;
  routerLink: string;
  iconName: string;
  iconClass: string;
  iconFontWeight?: number;
}

export const menuItems: MenuItem[] = [
  {
    label: 'Home',
    icon: '/assets/icons/home.svg',
    routerLink: 'home',
    iconName: 'dashboard',
    iconClass: 'dashboardIcon',
  },
  {
    label: 'Dashboard',
    icon: '/assets/icons/dashboard.svg',
    routerLink: 'dashboard',
    iconName: 'dashboardTile',
    iconClass: 'dashboardTileIcon',
    iconFontWeight: 50,
  },
  {
    routerLink: 'hawb',
    label: 'Shipments',
    icon: '/assets/icons/hawb.svg',
    iconName: 'hawb',
    iconClass: 'hawbIcon',
  },
  {
    iconName: 'bags',
    label: 'Bags',
    icon: '/assets/icons/bags.svg',
    routerLink: 'bag',
    iconClass: 'bagsIcon',
  },
  {
    iconClass: 'manifestIcon',
    label: 'Manifests',
    icon: '/assets/icons/manifest.svg',
    routerLink: 'manifest',
    iconName: 'manifest',
  },
  {
    label: 'Cancel / Recover Shipments',
    icon: '/assets/icons/cancel-recover-shipments.svg',
    routerLink: 'cancel-recover-shipments',
    iconName: 'cancelRecover',
    iconClass: 'cancelRecoverIcon',
  },
  {
    label: 'MAWBs',
    routerLink: 'mawb',
    iconName: 'mawb',
    iconClass: 'mawbIcon',
    icon: '/assets/icons/mawb.svg',
  },
  {
    label: 'Accounts Payable',
    icon: '/assets/icons/receivable.svg',
    routerLink: 'accounts-payable',
    iconName: 'accountPay',
    iconClass: 'accountIcon',
  },
  {
    label: 'Accounts Receivable',
    icon: '/assets/icons/payable.svg',
    iconName: 'accountReceive',
    routerLink: 'accounts-receivable',
    iconClass: 'accountsReceive ',
  },
  {
    label: 'Setup & Maintenance',
    routerLink: 'sm-dashboard',
    iconName: 'setting',
    icon: '/assets/icons/setting.svg',
    iconClass: 'settingIcon',
  },
  {
    label: 'Reports',
    icon: '',
    routerLink: 'reports',
    iconName: 'reports',
    iconClass: 'reportsIcon',
  },
];
